import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {NgxPermissionsService} from "ngx-permissions";
import {MsalService} from "@azure/msal-angular";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  baseUrl = environment.baseApiURL;
  constructor(private http: HttpClient,private permissionsService: NgxPermissionsService, private msalService: MsalService) { }


  public fetchUserRole(email:string) {
     return this.http.get<string>(this.baseUrl + `user/${email}`);
  }


  getPermissisons(){
    let user = this.msalService.instance.getAllAccounts()[0];
    this.fetchUserRole(user.username).subscribe({
      next:(res)=>{
        let perm:string[] = [];
        perm.push(res);
        this.permissionsService.loadPermissions(perm);
      },
      error:()=>{
        let perm:string[] = ['user'];
        this.permissionsService.loadPermissions(perm);
      }
    });
  }



}
